<template lang="html">
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
    methods:{
    }
}
</script>

<style lang="css" scoped>
</style>
